import { Check, Copy } from "@phosphor-icons/react";
import { IconButton } from "../../design-system";
import { useCopyToClipboard } from "./useCopyToClipboard";

/** Copy-to-clipboard with a transient ✓ on the trigger. */
export function CopyButton({
  value,
  label,
  onCopied,
}: {
  value: string;
  label: string;
  /** Fired after a successful copy (analytics hook, as on CodeBlock). */
  onCopied?: () => void;
}) {
  const { copied, copy } = useCopyToClipboard(onCopied);

  return (
    <IconButton
      variant="ghost"
      size="sm"
      icon={copied ? <Check className="text-success-fg" /> : <Copy />}
      aria-label={label}
      onClick={() => void copy(value)}
    />
  );
}
